import React, { Fragment, useState } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid'
import useQuery from '@/hooks/useQuery'

const REACTIONS = [
  { key: 'Like', icon: '👍' },
  { key: 'Seen', icon: '👀' },
  { key: 'Nope', icon: '👎' },
  { key: 'Rice', icon: '🍚' }
]

const ReactionButton = ({ reactionsData = {}, userReactions = [], reactionableId, reactionableType }) => {
  const { putpostRequest } = useQuery()
  const [reactions, setReactions] = useState(reactionsData)
  const [selectedReaction, setSelectedReaction] = useState(
    userReactions.find(r => r.reactionable_id === reactionableId && r.reactionable_type === reactionableType)?.reaction
  )

  const toggleReaction = (reaction) => {
    const oldReaction = selectedReaction
    setSelectedReaction(reaction)
    setReactions((prev) => {
      const next = { ...prev }
      next[reaction] = (next[reaction] || 0) + 1
      if (oldReaction) { next[oldReaction] = Math.max((next[oldReaction] || 1) - 1, 0) }
      return next
    })
    putpostRequest('/api/v1/reactions/toggle_reaction', 'POST', {
      reaction,
      reactionable_id: reactionableId,
      reactionable_type: reactionableType
    }, () => { /* fire-and-forget */ })
  }

  const counts = REACTIONS.filter(r => reactions[r.key] > 0)

  return (
    <Menu as='div' className='relative inline-block'>
      <Menu.Button className='inline-flex items-center gap-2 px-3 py-2 rounded-md border border-clcblue text-clcblue dark:text-white bg-white dark:bg-slate-900 hover:bg-clcblue hover:bg-opacity-10 transition-colors'>
        {counts.length === 0 ? (
          <span>👍</span>
        ) : (
          <span className='flex gap-2'>
            {counts.map(r => (
              <span key={r.key}>{r.icon} <span className='text-sm'>{reactions[r.key]}</span></span>
            ))}
          </span>
        )}
        <ChevronDownIcon className='h-3 w-3' />
      </Menu.Button>

      <Transition
        as={Fragment}
        enter='transition ease-out duration-100'
        enterFrom='transform opacity-0 scale-95'
        enterTo='transform opacity-100 scale-100'
        leave='transition ease-in duration-75'
        leaveFrom='transform opacity-100 scale-100'
        leaveTo='transform opacity-0 scale-95'
      >
        <Menu.Items className='absolute z-50 left-0 bottom-full mb-2 flex gap-1 p-2 rounded-lg bg-white dark:bg-slate-900 shadow-xl border border-slate-100 dark:border-slate-800 focus:outline-none'>
          {REACTIONS.map(r => (
            <Menu.Item key={r.key}>
              {({ active }) => (
                <button
                  onClick={() => toggleReaction(r.key)}
                  className={`flex items-center gap-2 px-3 py-2 text-xs font-medium rounded-md text-clcblue dark:text-white whitespace-nowrap transition-colors ${active || selectedReaction === r.key ? 'bg-clcblue bg-opacity-10' : ''}`}
                >
                  <span>{r.icon}</span>
                  <span>{r.key}</span>
                </button>
              )}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default ReactionButton
